import { closeWebsocket } from '@/store/utils'

export default () => {
  closeWebsocket()
}
